/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GlobalTemplateModule } from "@app/directives/global-template/global-template.module";
import { IconComponent } from "../icon/icon.component";
import { LayoutColComponent } from "./layout-col/layout-col.component";
import { LayoutGlobalControlsComponent } from "./layout-global-controls/layout-global-controls.component";
import { LayoutGroupComponent } from "./layout-group/layout-group.component";
import { LayoutItemComponent } from "./layout-item/layout-item.component";
import { LayoutRowComponent } from "./layout-row/layout-row.component";
import { LayoutToolbarComponent } from "./layout-toolbar/layout-toolbar.component";
import { LayoutComponent } from "./layout/layout.component";

@NgModule({
	declarations: [
		LayoutComponent,
		LayoutToolbarComponent,
		LayoutItemComponent,
		LayoutColComponent,
		LayoutRowComponent,
		LayoutGlobalControlsComponent,
		LayoutGroupComponent,
	],
	imports: [CommonModule, IconComponent, GlobalTemplateModule],
	exports: [
		LayoutComponent,
		LayoutToolbarComponent,
		LayoutItemComponent,
		LayoutColComponent,
		LayoutRowComponent,
		LayoutGlobalControlsComponent,
		LayoutGroupComponent,
	],
	providers: [],
})
export class LayoutModule { }
